'use client';

import React from 'react';
import { ExperienceType } from '../types';
import ExperienceVideos from '@/components/stay-experience/ExperienceVideos';

interface ExperienceVideosSectionProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceVideosSection: React.FC<
  ExperienceVideosSectionProps
> = ({ experience }) => {
  if (!experience) return null;

  const exp = experience as {
    tourGuideVideos?: Array<{
      thumbnailUrl?: string;
      imageUrl?: string;
      videoUrl?: string;
    }>;
    media?: Array<{
      format?: string;
      url?: string;
      thumbnailUrl?: string;
    }>;
  };

  // For activities and stays, check tourGuideVideos first, then media array
  const videos =
    Array.isArray(exp?.tourGuideVideos) && exp.tourGuideVideos.length > 0
      ? exp.tourGuideVideos.map(video => ({
          thumbnailUrl:
            video.thumbnailUrl ||
            video.imageUrl ||
            '/assets/images/No-Image.jpg',
          videoUrl: video.videoUrl || '',
        }))
      : Array.isArray(exp?.media)
        ? exp.media
            .filter(item => item.format === 'video')
            .map(video => ({
              thumbnailUrl: video.thumbnailUrl || '/assets/images/No-Image.jpg',
              videoUrl: video.url || '',
            }))
        : [];

  if (videos.length === 0) return null;

  return <ExperienceVideos videos={videos} />;
};
